import { orderRoutes, purchaseOrderRoutes } from '@zen/Routes';

import type { PurchaseOrderTableBannerConfig } from './types';
import { PurchaseOrderTableVersion } from './types';

const bannerConfigs: Record<PurchaseOrderTableVersion, PurchaseOrderTableBannerConfig> = {
  [PurchaseOrderTableVersion.CLASSIC]: {
    actionLabel: 'Use new PO table for more insights',
    icon: 'zicon-information-filled',
    message: 'You are using the Classic PO table.',
    targetUrl: purchaseOrderRoutes.index.getUrl(),
    targetVersion: PurchaseOrderTableVersion.NEW
  },
  [PurchaseOrderTableVersion.NEW]: {
    actionLabel: 'Switch back to Classic',
    icon: 'zicon-sparkles-filled',
    message: 'You are using the new PO table.',
    targetUrl: orderRoutes.index.getUrl(),
    targetVersion: PurchaseOrderTableVersion.CLASSIC
  }
};

export const getBannerConfig = (tableVersion: PurchaseOrderTableVersion): PurchaseOrderTableBannerConfig =>
  bannerConfigs[tableVersion];
